import { useMemo } from "react";
import { defineMessages } from "react-intl";
import classNames from "classnames";

import { useFormatMessage } from "../Intl/Context";
import { useRoutesContext } from "../Routes/RoutesContext";
import { useNonModalLocation } from "../Utils/routing";

export const useProfileTabsData = () => {
  const t = useFormatMessage();
  const labels = useMemo(
    () => ({
      informations: t(intlMessages.informations),
      settings: t(intlMessages.settings),
      contributions: t(intlMessages.contributions)
    }),
    [t]
  );

  const { pathFor } = useRoutesContext();
  const paths = useMemo(
    () => ({
      informations: pathFor("profileEdition"),
      settings: pathFor("profileSettings"),
      contributions: pathFor("profileContributions")
    }),
    [pathFor]
  );

  const { pathname } = useNonModalLocation();

  return useMemo(
    () =>
      ["informations", "settings", "contributions"].map(identifier => {
        const href = paths[identifier];
        const isActive = href === pathname;

        const className = classNames(
          "profile-link",
          "margin-x-sm",
          "padding-y-xs",
          "d-block",
          "text-black border-primary",
          {
            active: isActive,
            "text-decoration-none": isActive
          }
        );

        return {
          identifier,
          href,
          tabId: `profile-link-tab-${identifier}`,
          tabPanelId: `profile-tab-panel-${identifier}`,
          className,
          label: labels[identifier],
          isActive
        };
      }),
    [labels, pathname, paths]
  );
};

const intlMessages = defineMessages({
  informations: {
    id: "profile.links.informations",
    defaultMessage: "Mes données personnelles"
  },
  settings: {
    id: "profile.links.settings",
    defaultMessage: "Paramètres"
  },
  contributions: {
    id: "profile.header.contributions",
    defaultMessage: "Mes contributions"
  }
});
